import { API_BASE_URL } from './index';
import { callApi } from 'utils/callApi';

// eslint-disable-next-line import/prefer-default-export
export const addStudentRequest = ({ instituteId, yearBookId, name, email, contactNumber, studentLevel, role, isReceiveTestimonial }) =>
    callApi({
        requestFunction: (axios) =>
            axios.post(`${API_BASE_URL}/admin/students/add`, {
                instituteId,
                yearBookId,
                name,
                email,
                contactNumber,
                studentLevel,
                role,
                isReceiveTestimonial
            }),
        successCode: 201
    });

export const editStudentRequest = ({
    studentId,
    instituteId,
    yearBookId,
    name,
    email,
    contactNumber,
    studentLevel,
    role,
    isReceiveTestimonial
}) =>
    callApi({
        requestFunction: (axios) =>
            axios.put(`${API_BASE_URL}/admin/students/${studentId}`, {
                instituteId,
                yearBookId,
                name,
                email,
                contactNumber,
                studentLevel,
                role,
                isReceiveTestimonial
            }),
        successCode: 200
    });

export const toggleStudentStatusRequest = ({ studentId }) =>
    callApi({
        requestFunction: (axios) => axios.patch(`${API_BASE_URL}/admin/students/${studentId}`),
        successCode: 200
    });

export const getStudentsListRequest = ({ search, sortOrder, page, limit, yearBookId }) =>
    callApi({
        requestFunction: (axios) =>
            axios.post(`${API_BASE_URL}/web/users/students`, {
                search,
                sorted: sortOrder,
                limit,
                page
            }),
        successCode: 200,
        showToastOnSuccess: false,
        showToastOnError: true
    });

export const getStudentDetailsRequest = ({ studentId }) =>
    callApi({
        requestFunction: (axios) => axios.get(`${API_BASE_URL}/admin/students/${studentId}`),
        successCode: 200,
        showToastOnSuccess: false,
        showToastOnError: true
    });

export const deleteStudentRequest = ({ studentId }) =>
    callApi({
        requestFunction: (axios) => axios.delete(`${API_BASE_URL}/admin/students/${studentId}`),
        successCode: 200
    });

export const getStudentCoordinatorRequest = () =>
    callApi({
        requestFunction: (axios) => axios.get(`${API_BASE_URL}/web/users/coordinator-list`),
        successCode: 200,
        showToastOnSuccess: false,
        showToastOnError: false
    });
